import { Component, OnInit } from '@angular/core';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { MatDialogRef } from '@angular/material/dialog';

import { MatTableDataSource } from '@angular/material/table';
import { Observable, fromEvent } from 'rxjs';

@Component({
  selector: 'app-eligible-cities',
  templateUrl: './eligible-cities.component.html',
  styleUrls: ['./eligible-cities.component.css']
})
export class EligibleCitiesComponent implements OnInit {

  eventHeight: Observable<any> = fromEvent(window, "resize");
  innerHeight: number = window.innerHeight;

  eligibleCities: MatTableDataSource<any> = new MatTableDataSource();

  displayedColumns: string[] = ['postal_code', 'name', 'delivery_price','offered_from', 'map'];

  constructor(
    private dialogRef: MatDialogRef<EligibleCitiesComponent>,
    private tools: ToolsService
  ) { }

  ngOnInit() {
    this.onWindowResize();
    let pos:any =this.tools.getStor("point_of_sale");
    this.eligibleCities.data =pos.eligible_zones.map((zone:any) => {
       
      zone.city.offered_from = zone.offered_from;
      zone.city.delivery_price = zone.delivery_price;
      return zone.city;
    })
   
  }

  filterCities(ev: any) {
   let filterValue=ev.target.value;
    this.eligibleCities.filter = filterValue.trim().toLowerCase();
  }

  goGmap(lat: string, long: string) {
    window.open("https://www.google.com/maps/?q=" + lat + "," + long);
  }

  closeDial() {
    this.dialogRef.close();
  }

  onWindowResize() {
    this.eventHeight.subscribe(event => {
      this.innerHeight = event.target.innerHeight;
    });
  }


}
